import React from 'react';

import { navigationMessages } from '../../../translates/navigationMessages';
import { useIntlReexport } from '../../hooks/useIntlReexport';
import { BasicNavigationButtonProps } from './model';
import { NavigationBar } from '@ael/shared-components-library';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

interface NextNavigationButtonProps extends BasicNavigationButtonProps {
  icon?: IconProp;
}

export const NextNavigationButton = ({ icon = solid('angle-right'), ...props }: NextNavigationButtonProps) => {
  const { formatMessage } = useIntlReexport();

  return <NavigationBar.Button label={formatMessage(navigationMessages.next)} icon={icon} {...props} />;
};
